import queryString from 'query-string'
import get from 'lodash/get'
import last from 'lodash/last'
import { getNegotiatorapp } from '../../../../utils/getNegotiatorapp'

const _arcQueryParams = (itinerary) => {
  const departAirline = get(itinerary, 'slices[0].segment[0].marketingAirline')
  let returnAirline = null

  if (itinerary.slices.length !== 1) {
    const lastSlice = last(itinerary.slices)
    returnAirline = get(lastSlice, 'segment[0].marketingAirline')
  }

  return {
    arc: `${departAirline}-${returnAirline || ''}`,
  }
}

const newTabDetailsWithUpsell = ({
  token,
  slicesURL,
  searchKey,
  itinerary,
  checkoutUrl,
  offerToken,
  workflowId,
  userActionType,
  isUpsold = false,
}) => {
  const negotiatorAppParams = getNegotiatorapp() === 'y' ? '&negotiatorapp=y' : ''
  const arcQueryParams = _arcQueryParams(itinerary)
  const upsoldParam = isUpsold ? '&has-been-upsold=true' : ''
  const userActionTypeParams = userActionType === 'MODIFY' ? 'MODIFY' : false
  const offerTokenQueryParams = offerToken ? `&offer-token=${offerToken}` : ''
  return `/m/fly/search${slicesURL}details/${token}${checkoutUrl}&${queryString.stringify(
    arcQueryParams
  )}&search-key=${searchKey}${offerTokenQueryParams}&workflow-id=${workflowId}&userActionType=${userActionTypeParams}${negotiatorAppParams}${upsoldParam}`
}

export { newTabDetailsWithUpsell, _arcQueryParams }
